import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import {
  Button,
  Input,
  InputGroup,
  InputRightElement,
  useColorMode,
} from "@chakra-ui/react";
import { useState } from "react";

export default function PasswordInput({
  placeholder,
  value,
  onChange,
  register,
  autoComplete = "off",
}) {
  const { colorMode } = useColorMode();
  const [show, setShow] = useState(false);
  const handleClick = () => setShow(!show);

  return (
    <InputGroup size="md">
      {register ? (
        <Input
          pr="4.5rem"
          type={show ? "text" : "password"}
          placeholder={placeholder || ""}
          bgColor={colorMode === "dark" ? "#939BA9" : "white"}
          {...register}
        />
      ) : (
        <Input
          pr="4.5rem"
          type={show ? "text" : "password"}
          placeholder={placeholder || ""}
          value={value}
          bgColor={colorMode === "dark" ? "#939BA9" : "white"}
          onChange={onChange}
        />
      )}
      <InputRightElement width="4.5rem">
        <Button type="button" h="1.75rem" size="sm" onClick={handleClick}>
          {show ? <ViewOffIcon /> : <ViewIcon />}
        </Button>
      </InputRightElement>
    </InputGroup>
  );
}
